// @flow

import React from 'react';
import bemify, { toModifiers } from 'bemify-js';
import { noop } from 'lodash';

import { createKeyHandler } from '@zapier/common-utils';

import { routes } from 'web-ssr/app/common/next/routes';
import 'web-ssr/app/common/components/Link.scss';

import type { Node } from 'react';

import type { DisplayTarget, KindType } from 'web-ssr/app/common/types';

const { Link: NextRouterLink } = routes;

const bem = bemify('link');

type BaseProps = {
  children: Node,
  target?: DisplayTarget,
  className?: string,
  itemprop?: string,
  kind?: KindType,
  rel?: string,
  onClick?: (event: SyntheticEvent<>) => any,
};

type RouterLinkProps = {
  ...$Exact<BaseProps>,
  as?: string | {},
  href?: string | {},
  params?: {},
  passHref: boolean,
  prefetch: boolean,
  replace: boolean,
  route?: string,
  scroll: boolean,
  shallow: boolean,
};

const Link = (props: RouterLinkProps) => {
  const {
    as,
    children,
    className,
    href,
    itemprop,
    kind,
    onClick = noop,
    params,
    passHref,
    prefetch,
    replace,
    route,
    scroll,
    shallow,
    target,
    rel,
  } = props;

  return (
    <NextRouterLink
      as={as}
      href={href}
      params={params}
      passHref={passHref}
      prefetch={prefetch}
      replace={replace}
      route={route}
      scroll={scroll}
      shallow={shallow}
    >
      <a // eslint-disable-line jsx-a11y/anchor-is-valid
        className={bem(className, toModifiers(kind))}
        itemProp={itemprop}
        onClick={onClick}
        onKeyDown={createKeyHandler(['enter'], onClick)}
        rel={rel}
        role="button"
        tabIndex="0"
        target={target}
      >
        {children}
      </a>
    </NextRouterLink>
  );
};

Link.defaultProps = {
  passHref: true,
  prefetch: false,
  replace: false,
  shallow: false,
  scroll: false,
};

export default Link;
